import React from "react";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import CustomBtn from "./ButtonTemplate";

interface AddNoteBtnProps {
  action: () => void;
  tip?: string;
}

function AddNoteBtn({ action, tip = "Notes" }: AddNoteBtnProps) {
  return (
    <CustomBtn action={action} type="info" icon={<NoteAddIcon />} tip={tip} />
  );
}

export default AddNoteBtn;
